'use strict';
angular.module('resourceCenterRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.resourcectrl', {
                url: '/resourcectrl',
                views: {
                    main: {
                        templateUrl: './resourceCenter/resourceCenter.html',
                        controller: 'resourceCenterController'
                    },
                    'left@front.resourcectrl': {
                        templateUrl: './resourceCenter/left/left_tpl.html',
                        controller: 'resourceCenterLeft',
                    },
                },
            })
            .state('front.resourcectrl.xinhua', {
                // 新华社稿
                url: '/xinhua?typename&modalid&relateddetail', // relateddetail 关联稿件 1  ",
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.xjrb', {
                // 新华社稿
                url: '/xjrb?typename&modalid&relateddetail', // relateddetail 关联稿件 1  ",
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.material', {
                // 素材库
                url: '/material?typename&modalid&relateddetail',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.share', {
                // 共享稿库
                url: '/share?typename&modalid&isugc&iscrosstenant',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.propagandamanuscript', {
                // 公共素材库
                url: '/propagandamanuscript?typename&modalid&isugc',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.materials', {
                // 公共素材库
                url: '/materials?typename&modalid&isugc',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            }).state('front.resourcectrl.mediaresource', {
                // 媒资库
                url: '/mediaresource?typename&modalid&isugc',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.tenantmanuscript', {
                // 租户间稿库
                url: '/tenantmanuscript',
                views: {
                    'main@front.resourcectrl': {
                        template: "<div ui-view='main'></div>",
                    },
                },
            })
            .state('front.resourcectrl.classifiedresource', {
                // 分类资源集合
                url: '/classifiedresource',
                views: {
                    'main@front.resourcectrl': {
                        template: "<div ui-view='main'></div>",
                    },
                },
            })
            .state('newspaperRemark', {
                // 评报系统
                url: '/newspaperRemark?type&typetwo&paperid$sitename&change', // paperid -> 报纸ID type -> 评论类型
                views: {
                    '': {
                        templateUrl: './resourceCenter/newspaperRemark/list.html',
                    },
                    'left@newspaperRemark': {
                        templateUrl: './resourceCenter/newspaperRemark/left/left_tpl.html',
                        controller: 'NewspaperRemarkLeftCtrl',
                    },
                    // 'right@newspaperRemark': {
                    //     templateUrl: function($stateParams, user) {
                    //         var dictionary = {
                    //             'pbgl': './resourceCenter/newspaperRemark/remarklist.html',
                    //             'sd': './resourceCenter/newspaperRemark/remarkChannel/remarkChannel.html',
                    //             'zd': './resourceCenter/newspaperRemark/remarkChannel/remarkChannelZD.html',
                    //         };
                    //         var templateUrl = '';
                    //         if ($stateParams.type === 'pbl' && $stateParams.typetwo === 'sd') {
                    //             templateUrl = dictionary.sd;
                    //         } else if ($stateParams.type === 'pbl' && $stateParams.typetwo === 'zd'){
                    //             templateUrl = dictionary.zd;
                    //         } else {
                    //             templateUrl = dictionary.pbgl;
                    //         }  
                    //         return templateUrl;
                    //     },
                    //     controller: 'NewspaperRemarkListCtrl',
                    // },
                },
            }).state('newspaperRemark.toolbar', {
                url: '/toolbar',
                views: {
                    'right@newspaperRemark': {
                        templateUrl: function($stateParams) {
                            var dictionary = {
                                'pbgl': './resourceCenter/newspaperRemark/remarklist.html',
                                'sd': './resourceCenter/newspaperRemark/remarkChannel/remarkChannel.html',
                                'zd': './resourceCenter/newspaperRemark/remarkChannel/remarkChannelZD.html',
                            };
                            var templateUrl = '';
                            if ($stateParams.type === 'pbl' && $stateParams.typetwo === 'sd') {
                                templateUrl = dictionary.sd;
                            } else if ($stateParams.type === 'pbl' && $stateParams.typetwo === 'zd'){
                                templateUrl = dictionary.zd;
                            } else {
                                templateUrl = dictionary.pbgl;
                            }  
                            return templateUrl;
                        },
                        controller: 'NewspaperRemarkListCtrl',
                    },
                },
            })
            .state('newspaperRemarkDetail', {
                // 读报评报二级页面
                url: '/newspaperRemarkDetail?nodeid&bc&docpubtime&serviceid&papername',
                views: {
                    '': {
                        templateUrl: './resourceCenter/newspaperRemark/detail/newspaperRemarkDetail.html',
                        controller: 'NewspaperRemarkDetailCtrl',
                    },
                },
            })
            .state('front.resourcectrl.featuredresource', {
                // 特色资源集合
                url: '/featuredresource',
                views: {
                    'main@front.resourcectrl': {
                        template: "<div ui-view='main'></div>",
                    },
                },
            })
            .state('front.resourcectrl.multimediaresource', {
                // 多媒体资源集合
                url: '/multimediaresource',
                views: {
                    'main@front.resourcectrl': {
                        template: "<div ui-view='main'></div>",
                    },
                },
            })
            .state('front.resourcectrl.stock', {
                // 集团成品库
                url: '/stock?typename',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.theme', {
                // 主题稿库
                url: '/theme?typename',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.video', {
                // 视频库
                url: '/video?typename',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/resource_main_tpl.html',
                    },
                },
            })
            .state('front.resourcectrl.more', {
                url: '/more?type&method',
                views: {
                    'body@resourcectrl': {
                        templateUrl: './planningCenter/cueSelectedTopic/cueMonitoring/more/cueMonitorMore_tpl.html',
                        controller: 'cueMonitorMoreCtrl',
                    },
                },
            })
            .state('front.resourcectrl.type', {
                url: '/information?type&keyword',
                views: {
                    'body@resourcectrl': {
                        templateUrl: './planningCenter/cueSelectedTopic/cueMonitoring/more/cueMonitorMore_tpl.html',
                        controller: 'planCenterTrelatedinformationCtrl',
                    },
                },
            })
            .state('front.resourcectrl.hotKey', {
                url: '/eventcorrelation?hotKey',
                views: {
                    'body@resourcectrl': {
                        templateUrl: './planningCenter/cueSelectedTopic/cueMonitoring/more/cueMonitorMore_tpl.html',
                        controller: 'planCenterEventCorrelationHotKeyCtrl',
                    },
                },
            })
            .state('resourcedetail', {
                // 资源中心细览详情 onlyimageorcontent：1只显示图片，2只显示正文  relateddetail 相关稿件 1 
                // historystore：新疆日报历史稿库跳详情
                url: '/resourcedetail?guid&channel&indexname&frompictures&onlyimageorcontent&&relateddetail&historystore',
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/detail_tpl.html',
                        controller: 'resourceCenterDetailCtrl',
                    },
                },
            })
            .state('resourcepushdetail', {
                // 资源中心push稿细览详情
                url: '/resourcepushdetail?guid&indexname&isToutiao&relateddetail&iscollect', // relateddetail 2 高级检索 iscollect 是否是收藏来的
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/pushDetail_tpl.html',
                        controller: 'resourceCenterPushDetailCtrl',
                    },
                },
            })
            .state('resourcerobotdetail', {
                // 资源中心机器人稿细览详情
                url: '/resourcerobotdetail?guid',
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/robotDetail_tpl.html',
                        controller: 'resourceCenterRobotDetailCtrl',
                    },
                },
            })
            .state('resourcexhsgbigdatadetail', {
                // 资源中心新华社稿大数据细览详情
                url: '/resourcexhsgbigdatadetail?type&docid&channel', // relateddetail 高级检索 2
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/xinhuaDetail_tpl.html',
                        controller: 'resourceCenterXhsgBigdataDetailCtrl',
                    },
                },
            })
            .state('appresourcedetail', {
                // 辅助写作细览
                url: '/appresourcedetail?guid&indexname',
                views: {
                    '': {
                        templateUrl: './resourceCenter/appresourcedetail/appresourcedetail_tpl.html',
                        controller: 'appResourceDetailCtrl',
                    },
                },
            })
            .state('resourcegxgkdetail', {
                // 资源中心共享稿库细览详情
                url: '/resourcegxgkdetail?metadataid&type&nodeid&frompictures&isugc&fromsearch',
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/gxgkDetail_tpl.html',
                        controller: 'resourceCenterGxgkDetailCtrl',
                    },
                },
            })
            .state('resourcepicturedetail', {
                // 资源中心图片素材细览详情
                url: '/resourcepicturedetail?nodeid&guid',
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/pictureDetail_tpl.html',
                        controller: 'resourceCenterPictrueDetailCtrl',
                    },
                },
            })
            .state('resourcevideomaterialdetail', {
                // 资源中心视频素材细览详情
                url: '/resourcevideomaterialdetail?nodeid&guid&channel&indexname',
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/videoMaterialDetail_tpl.html',
                        controller: 'resourceCenterVideoMaterialDetailCtrl',
                    },
                },
            })
            .state('resourcevideodetail', {
                // 成品稿库-电视台-视频详情
                url: '/resourcevideodetail?guid',
                views: {
                    '': {
                        templateUrl: './resourceCenter/detail/videoDetail_tpl.html',
                        controller: 'resourceCenterVideoDetailCtrl',
                    },
                },
            });
    },
]);
